import { render, staticRenderFns } from "./ProductHeaderItem.vue?vue&type=template&id=560a7e1e&scoped=true&"
import script from "./ProductHeaderItem.vue?vue&type=script&lang=js&"
export * from "./ProductHeaderItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductHeaderItem.vue?vue&type=style&index=0&id=560a7e1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560a7e1e",
  null
  
)

export default component.exports